import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "accept"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.labelText || _ctx.labelIcon)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.idTag,
          class: _normalizeClass(_ctx.customClasses)
        }, [
          _createTextVNode(_toDisplayString(_ctx.labelText) + " ", 1),
          (_ctx.labelIcon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass([_ctx.labelIcon, "primary"])
              }, null, 2))
            : _createCommentVNode("", true)
        ], 10, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: "file",
      style: {"display":"none"},
      ref: "fileImport",
      id: _ctx.idTag,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.processSelection($event.target))),
      accept: _ctx.accept
    }, null, 40, _hoisted_2)
  ]))
}